import type {
  DeclareInput,
  DeclareWithdrawalResult,
  LookupInput,
  WithdrawalLookupResult,
} from "@trydig/withdrawal";

export const lookupOrderAction = async (
  input: LookupInput
): Promise<WithdrawalLookupResult> => {
  const res = await fetch("/api/withdrawal/lookup", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(input),
  });

  if (!res.ok) throw new Error("Failed to look up order");

  return res.json();
};

export const declareWithdrawalAction = async (
  input: DeclareInput
): Promise<DeclareWithdrawalResult> => {
  const res = await fetch("/api/withdrawal/declare", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(input),
  });

  if (!res.ok) throw new Error("Failed to declare withdrawal");

  return res.json();
};
